<!-- 编辑设备详情弹框 -->
<template>
  <div class="edit-container">
    <el-form :model="deviceForm"
             ref="refForm"
             label-width="100px">
      <el-col :span="12">
        <el-form-item label="名称"
                      prop="parentDeviceName">
          <el-input v-model="deviceForm.parentDeviceName"
                    :disabled="deviceForm.deviceMark==34"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="区域"
                      prop="areaName">
          <el-input v-model="deviceForm.areaName"
                    disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通信ID"
                      prop="parentThirdDeviceId">
          <el-input v-model="deviceForm.parentThirdDeviceId"
                    disabled>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="规格型号"
                      prop="parentDeviceVersion">
          <el-input v-model="deviceForm.parentDeviceVersion"
                    disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12"
              v-if="deviceForm.parentDeviceExtendMap">
        <el-form-item label="制造厂"
                      prop="parentDeviceExtendMap">
          <el-input v-model="deviceForm.parentDeviceExtendMap.manufacturer"
                    disabled>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12"
              v-if="deviceForm.deviceMark==34">
        <el-form-item label="探测器名称"
                      prop="deviceName">
          <el-input v-model="deviceForm.deviceName">
          </el-input>
        </el-form-item>
      </el-col>
<!--
      <el-col :span="12">
        <el-form-item label="是否室内"
                      prop="isIndoor">
          <el-select v-model="deviceForm.isIndoor"
                     @change="selectChange">
            <el-option v-for="item in isIndoorList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col> -->
      <el-col :span="12"
              v-if="deviceForm.isIndoor==1">
        <el-form-item label="所属楼栋"
                      prop="buildingName">
          <el-input v-model="deviceForm.buildName"
                    class="position-set"
                    placeholder="请标记室内位置"></el-input>
          <el-button type="text"
            size="small"
            style="position: absolute; right: 0px; font-size: 18px; top: -3px"
            class="iconfont icon-position choose-person"
            title="选择楼栋"
                     @click="openBuilding"></el-button>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属楼层"
                      prop="floorName">
          <el-input v-model="deviceForm.floorName"
                    class="position-set"
                    disabled
                    ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12"
              v-if="deviceForm.isIndoor==0">
        <el-form-item label="经度"
                      prop="longitude">
          <div>
            <el-input v-model="deviceForm.longitude"
                      class="position-set"
                      placeholder="请输入经度"></el-input>
            <el-button type="text"
            size="small"
            title="选择位置"
            style="position: absolute; right: 0px; font-size: 18px; top: -3px"
            class="iconfont icon-position choose-person"
                       @click="openMap"></el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12"
              v-if="deviceForm.isIndoor==0">
        <el-form-item label="纬度"
                      prop="latitude">
          <div>
            <el-input v-model="deviceForm.latitude"
                      class="position-set"
                      placeholder="请输入纬度"></el-input>
                      <el-button type="text"
            size="small"
            title="选择位置"
            style="position: absolute; right: 0px; font-size: 18px; top: -3px"
            class="iconfont icon-position choose-person"
                       @click="openMap"></el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="备注"
                      prop="parentDeviceDescription">
          <el-input v-model="deviceForm.deviceDescription"
                    class="position-set"
                    v-if="deviceForm.deviceMark==34"
                    type="textarea"
                    placeholder="请输入备注"></el-input>
          <el-input v-model="deviceForm.parentDeviceDescription"
                    class="position-set"
                    type="textarea"
                    v-else
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <!-- 引入gis地图 -->
    <el-dialog title="从地图选择"
               width="800px"
               v-dialogDrag
               :visible.sync="showMap"
               @close="mapClose"
               :modal="false"
               @click="mapCancleOpt">
      <div id="map-container">
        <AppMap ref="refAppMap" divId="miniMap" />
      </div>
      <!-- 底部操作按钮 -->
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="mapCancleOpt">{{
          $t("taskCenter.button.cancel")
        }}</el-button>
        <el-button type="primary"
                   @click="mapConfirmOpt">{{
          $t("taskCenter.button.conform")
        }}</el-button>

      </span>
    </el-dialog>
    <!-- 楼栋树 -->
    <el-dialog title="楼栋选择"
    width="70%"
               v-dialogDrag
               :visible.sync="showBuilding"
               @close="mapClose"
               :modal="false"
               @click="mapCancleOpt">
      <!--左侧楼栋树-->
      <div class="flex-container">
        <div class="flex-valign left-tree">
          <div class="left-type_area">
              <div class="tree-container">
              <div class="area-title">楼栋信息</div>
              <div class="area-search">
                <el-input
                  v-model="searchString"
                  clearable
                  placeholder="请输入搜索关键字"
                  prefix-icon="el-icon-search"
                >
                </el-input>
              </div>
              <el-scrollbar class="scroll-bar-view"
                            style="height: 600px">
                <el-tree
                         ref="tree"
                         class="tree-content"
                         :data="treeData"
                         :expand-on-click-node="false"
                         node-key="id"
                         :default-expanded-keys="expandedKeys"
                         :props="treeProps"
                         :highlight-current="true"
                         :filter-node-method="filterNode"
                         @node-click="nodeClick">
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </div>

        <!--右侧展示图纸-->
        <!-- 右侧图纸 -->
        <div class="right-img">
          <div class="canvasMain">
            <div class="canvasMainT"
                 :style="{
                width: vW + '%',
                height: vH + '%',
                marginTop: getMarginTop + 'px',
                marginLeft: getMarinLeft + 'px',
              }">
              <img id="building-img"
                   :src="
                  rootDefaultDrawing
                    ? '/images/theme/newDark/default-drawing1.jpg'
                    : imgUrl
                " />
              <canvas id="mycanvas"
              style="cursor: all-scroll"
                @mousewheel="mouseScroll"
                @DOMMouseScroll="mouseScroll"
                @mousedown="handleDomMoveStart"
                :width="cW"
                :height="cH"></canvas>
            </div>
          </div>
        </div>
          <div class="coord">
          <span> 【 缩放比例 {{ vW }}% 】 </span>
          【相对坐标 X：{{ x }} ，Y：{{ y }} 】
        </div>
      </div>

      <!--操作按钮-->
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="camCancelOpt">取消</el-button>
        <el-button type="primary"
                   @click="camConfirmOpt">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import { Bus } from "$utils";
import deviceMap from "../components/deviceMap";
import AppMap from "@src/components/common/gis/index";
export default {
  components: {
    AppMap
  },
  props: {
    gasDeviceInfo: {
      type: Object,
      default () {
        return {};
      },
    },
  },

  data () {
    return {
      deviceForm: {
        isIndoor: 1
      },
      isShow: false,
      isIndoorList: [
        {
          label: "是",
          value: "1",
        },
        // {
        //   label: "否",
        //   value: "0",
        // },
      ],
      rootDefaultDrawing: true,
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      x: "",
      y: "",
      imgUrl: "",
      showTree: true,
      buildingCode: "",
      showBuilding: false,
      treeData: Object.freeze([]),
      searchString: "",
      expandedKeys: [],
      lazyLoad: false,
      cW: 0,
      cH: 0,
      canvasList: [],
      treeDate: [],
      deviceTreeShow: false,
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName",
      },
      // 区域树对象
      areaTrData: [],
      showMap: false,
      point: {},
      areaCopy: {},
      setTimeNum: 0,
      tipImg: {},
      handleClickTime: null,
    };
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop () {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft () {
      return this.marginLeft + this.moveXDistance;
    },
  },
  mixins: [deviceMap],
  watch: {
    gasDeviceInfo: {
      handler: function (newVal) {
        this.deviceForm = JSON.parse(JSON.stringify(newVal))
        this.deviceForm.isIndoor = 1
        // console.log(this.deviceForm)
      },
      immediate: true

    },
    vH () {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
    searchString: {
      handler(val) {
        this.$refs.tree.filter(val);
      },
    },
    showBuilding (newVal, oldVal) {
      if (oldVal) {
        this.clearCanvas();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.handleClickTime);
    window.onresize = null;
  },
  mounted () {
    this.tipImg[10001] = new Image();
    this.tipImg[10001].src = require("/public/images/theme/newDark/map/default_device.png");
  },
  methods: {
    //输入框选择是否在室内，否：关经纬度，显示楼栋，是：开经纬度，关楼栋
    selectChange (val) {
      //
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode (node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode (value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    queryBuildingTree () {
      this.$fetch(api.queryBuildingTree).then((res) => {
        const result = this.menusDataPro(res.returnObj);
        this.treeData = Object.freeze(result);
        this.expandedKeys = [
          this.deviceForm.buildingId ||
            this.deviceForm.buildingCode ||
            this.treeData[0].id,
        ];
        // this.$refs.tree.setCheckedKeys([this.deviceForm.buildingCode] || []);
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey({
            id: this.deviceForm.buildingCode || this.deviceForm.buildingId,
          });
        });
      });
    },

    // // 检索树
    // filterText () {
    //   if (!this.searchString) {
    //     this.showTree = false;
    //     this.$nextTick(() => {
    //       this.showTree = true;
    //     });
    //     this.queryBuildingTree();
    //     return;
    //   }
    //   this.$refs.tree.filter(this.searchString.trim());
    // },
    // //重置
    // clearSearch () {
    //   this.searchString = "";
    //   this.filterText();
    // },
    // 打开楼栋选择
    openBuilding () {
      this.showBuilding = true;
      if (this.deviceForm.fileCode) {
        this.rootDefaultDrawing = false;
      } else {
        this.rootDefaultDrawing = true;
      }
      this.imgUrl = this.getImgPath(this.deviceForm.fileCode);
      this.canvasList = [
        {
          abscissa: this.deviceForm.abscissa,
          ordinate: this.deviceForm.ordinate,
          width: this.deviceForm.width,
          height: this.deviceForm.height,
        },
      ];

      this.queryBuildingTree(); //楼栋树
      this.$nextTick(() => {
        this.clickPoints(); //画布添加事件
        this.getCanvasWH(); //回显打点
        let _this = this;
        window.onresize = function () {
          _this.watchScreen();
        };
      });
    },
    // 窗口改变事件
    watchScreen () {
      this.getCanvasWH();
    },
    // 点击节点
    nodeClick (data) {
      // 清空已存在的数据和画布
      if (data.type != 2) {
        this.$message.warning("请将设备标记在楼层图纸上");
        return;
        //
      }
      this.clearCanvas();
      this.x = this.y = "";
      // copy选中数据
      this.areaCopy = {
        name: data.name,
        id: data.id,
      };
      this.parentCode = data.parentCode;
      this.state = 3;
      this.fileList = [];
      // console.log(data.fileCode, "---data");
      if (!data.fileCode) {
        this.rootDefaultDrawing = true;
      } else {
        this.rootDefaultDrawing = false;
        this.deviceForm.fileCode = data.fileCode;
        this.imgUrl = this.getImgPath(this.deviceForm.fileCode);
      }
    },
    getImgPath (item) {
      return item ? Bus.imgPath(item) : "";
    },
    //递归树结构
    menusDataPro (data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.buildingCode;
          entity.name = item.buildingName;
          entity.parentCode = item.parentCode;
          entity.parentName = item.parentName;
          entity.type = item.type;
          entity.fileCode = item.fileCode;
          entity.desc = item.desc;
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList;
          if (item.subBuildingList) {
            entity.children = self.menusDataPro(item.subBuildingList);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // 画布添加点击事件
    clickPoints () {
      let that = this;
      let x, y;
      var canvas = document.getElementById("mycanvas");
      canvas.addEventListener("click", function (e) {
        clearInterval(that.handleClickTime);
        if (that.setTimeNum < 3) {
          // 超时默认移动事件
          that.showCamImg(e);
          this.setTimeNum = 0;
        }
      });
      canvas.addEventListener(
        "mousemove",
        function (e) {
          this.setTimeNum = 0;
          if (e.pageX || e.pageY) {
            x = e.offsetX;
            y = e.offsetY;
          } else {
            x =
              e.clientX +
              document.body.scrollLeft +
              document.documentElement.scrollLeft;
            y =
              e.clientY +
              document.body.scrollTop +
              document.documentElement.scrollTop;
          }
          that.x = x;
          that.y = y;
        },
        false
      );
      canvas.addEventListener(
        "mousedown",
        function (e) {
          that.setTimeNum = 0;
          if (that.handleClickTime) {
            clearInterval(that.handleClickTime);
          }
          that.handleClickTime = setInterval(() => {
            that.setTimeNum++;
          }, 100);
        },
        false
      );
    },
    // 获取canvas father W H
    getCanvasWH () {
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.mathCanvas();
    },
    // 画布点击回调
    showCamImg (e) {
      this.clearCanvas();
      let x = e.offsetX;
      let y = e.offsetY;
      this.canvasList = [
        {
          abscissa: x,
          ordinate: y,
          width: this.cW,
          height: this.cH,
        },
      ];
      this.x = x;
      this.y = y;
      this.mathCanvas();
    },
    mathCanvas() {
      this.clearCanvas();
      let img = this.tipImg[10001];
      let ctx = this.initCanvas();
      if (this.canvasList.length) {
        this.canvasList.forEach((el) => {
          // 只渲染当前楼层点位
          // if (el.floorId != this.floorInfo.buildingCode) {
          //   return;
          // }
          let wb = this.cW / Number(el.width);
          let hb = this.cH / Number(el.height);
          this.$nextTick(() => {
            ctx.drawImage(
              img,
              Math.round(Number(el.abscissa) * wb - 25),
              Math.round(Number(el.ordinate) * hb - 25),
              50,
              50
            );
          });
        });
      }
    },
    // 画布确定回调
    camConfirmOpt () {
      // if (!this.x || !this.y || !this.areaCopy.id) {
      //   this.$message.warning("请选择所属楼栋和设备位置后提交数据");
      //   return;
      // }
      let checkNode = this.$refs.tree.getCurrentNode();
      // console.log(checkNode);
      if (!checkNode || !checkNode.id || checkNode.type != 2) {
        this.$message.warning("请选择设备所属所属楼栋/楼层");
        return;
      }
      if (!this.canvasList.length) {
        this.$message.warning("请标记设备在图纸位置");
        return;
      }
      this.showBuilding = false;
      this.deviceForm.buildingName = checkNode.name;
      this.deviceForm.buildingCode = checkNode.id; //必须传，选中节点id
      this.deviceForm.buildName =
        checkNode.type == 2 ? checkNode.parentName : checkNode.name; //楼栋名称
      this.deviceForm.buildingId =
        checkNode.type == 2 ? checkNode.parentCode : checkNode.id; //楼栋id
      this.deviceForm.floorId = checkNode.type == 2 ? checkNode.id : ""; //楼层id
      this.deviceForm.floorName = checkNode.type == 2 ? checkNode.name : ""; //楼层名称
      this.deviceForm.abscissa = this.canvasList[0].abscissa;
      this.deviceForm.ordinate = this.canvasList[0].ordinate;
      this.deviceForm.width = this.cW;
      this.deviceForm.height = this.cH;
      this.deviceForm.fileCode = this.fileCode;
      this.camCancelOpt();
    },
    camCancelOpt () {
      this.imgUrl = "";
      this.canvasList = [];
      this.showBuilding = false;
      this.rootDefaultDrawing = true;
      this.setTimeNum = 0;
      this.handleClickTime && clearInterval(this.handleClickTime);
      window.onresize = null;
    },
    validateForm () {
      return new Promise(this.$refs.iocForm.validate);
    },
    clearValidate () {
      this.$refs.iocForm.clearValidate();
    },
    initMap () {
      // debugger
      // this.$map.MapInstance2D.setMapOption();
      // this.$map.MapInstance2D.resetMapStyle("map-container");
      // this.$map.MapInstance2D.getLocation(this.getLocationCB);
      this.$refs.refAppMap.getLocation(this.getLocationCB);
      if (this.deviceForm.longitude) {
        let coord = [
          // 118.3050084314,
          // 35.0584137440,
          Number(this.deviceForm.longitude),
          Number(this.deviceForm.latitude),
        ];
        this.$refs.refAppMap.setMapCenter(coord);
        this.getLocationCB(coord); //h回显已配置的点位
      } else {
        this.$refs.refAppMap.setMapCenter();
      }
    },
    getLocationCB (event) {
      // this.point = event;
      // let option = [
      //   {
      //     id: "point_" + new Date().getTime(),
      //     coord: this.point,
      //     src: "images/theme/newDark/map/resource/position_red.png",
      //   },
      // ];
      // this.$map.MapInstance2D.clearPoint();
      // this.$map.MapInstance2D.addMarket(option);
      let option = [
        {
          id: "point_" + new Date().getTime(),
          coord: [event[0], event[1]],
          src: "images/theme/newDark/map/resource/position_red.png",
          anchor: [10, 20],
        },
      ];
      this.point = [event[0], event[1]];
      this.$refs.refAppMap.removePoint("devicePointId");
      this.$refs.refAppMap.addMarket(option, "devicePointId");
    },
    openMap () {
      this.showMap = true;
      // this.$nextTick(() => {
      //   this.$map.showMap2D(this.initMap);
      // });
      setTimeout(() => {
        this.initMap()
      }, 200)
    },
    mapClose () {
      this.$map.hideMap2D();
    },
    // 点击地图框中的取消操作
    mapCancleOpt () {
      this.showMap = false;
      this.$map.hideMap2D();
    },
    mapConfirmOpt () {
      this.deviceForm.longitude = Number(this.point[0]).toFixed(10);
      this.deviceForm.latitude = Number(this.point[1]).toFixed(10);

      this.showMap = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-container {
  width: 100%;
  height: 100%;
  .position-set {
    position: relative;
  }
  .coord {
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 0%;
    min-width: 210px;
    background: rgba(13, 18, 28, 0.7);
    padding: 5px 10px;
    color: #fff;
  }
  .area-title {
    margin: 10px 0 16px 10px;
    border-left: 5px solid #407aee;
    padding-left: 10px;
    font-size: 14px;
  }
  :deep .el-tree-node__content {
    height: 32px;
    line-height: 32px;
  }
  .area-search {
    margin: 12px;
  }
  .map-choose {
    position: absolute;
    right: -5px;
    top: 0px;
  }
  #map-container {
    height: 450px;
  }
  .flex-container {
    display: flex;
    position: relative;
    .left-tree {
      // width: 45%;
      // float: left;
      // display: inline;
      flex: 1;
      height: 500px;
    }
    .right-img {
      margin-left: 12px;
      flex: 2;

      #building-img {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .canvasMain {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background: rgba(128, 128, 128, 0.5);
      .canvasMainT {
        position: absolute;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }
        canvas {
          position: absolute;
        }
      }
    }
  }
  .buildingDialog-footer {
    margin-top: 30px;
  }
}
</style>


